import React from "react";
import { Handle, Position } from "reactflow";

const EndNodeComponent: React.FC = () => {
    return (
        <div className="workflow-end-node d-flex flex-column align-items-center" aria-label="End">
            <Handle type="target" position={Position.Top} className="workflow-end-node-handle" />
            <div className="workflow-end-node-line" />
            <div className="workflow-end-node-pill">End</div>
        </div>
    );
};

export const EndNode = React.memo(EndNodeComponent);
